module.exports = __webpack_public_path__ + "img/ImGletscher2.13226c86.jpg";